import { render, staticRenderFns } from "./AddNewRequest.vue?vue&type=template&id=41c35d72&scoped=true&"
import script from "./AddNewRequest.vue?vue&type=script&lang=ts&"
export * from "./AddNewRequest.vue?vue&type=script&lang=ts&"
import style0 from "./AddNewRequest.vue?vue&type=style&index=0&id=41c35d72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c35d72",
  null
  
)

export default component.exports